export default "__VITE_ASSET__CBo7iL2W__"